/* eslint-disable */ import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import StyledDragAndDropArea from './DragAndDropArea.styles';
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/arrow-right.svg';
import { Button } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import ErrorMappingModal from '../ErrorMappingModal/ErrorMappingModal';
import ErrorBalanceModal from '../ErrorBalanceModal/ErrorBalanceModal';
import ErrorCountRecordsModal from '../ErrorCountRecordsModal/ErrorCountRecordsModal';
import FileUpload from '../FileUpload/FileUpload';
import {
  setLoading,
  setUploadFile,
  unsetLoading,
  unsetUploadFile,
  setDiscount,
  setFileMetadata,
} from '../../store/order/orderSlice';
import { parseFile, createCsvFile, convertToBase64 } from '../../utils/parsingFileHelper';
import { getUploadFileName } from '../../utils/getUploadFileName';
import {
  MAX_UPLOAD_FILE_SIZE_BYTES,
  MAX_UPLOAD_FILE_SIZE_LABEL,
} from '../../utils/uploadLimits';
import AddSkipTraceModal from '../AddSkipTraceModal';
import MappingData from '../MappingData';
import {
  SkipTraceFileHeaders,
  SkipTraceFileTypeENUM,
  isValidFileHeaders,
  SkipTraceFileRequiredHeaders,
  SkipTraceFieldMapping,
  popStreamFileHeaders,
  popStreamFileFieldMapping,
  OwnerTypeENUM,
  BusinessTypeENUM,
  ScrubTypeENUM,
} from "../../utils/skipTraceFileHeaders";
import Bill from '../Bill/Bill';
import config from '../../config';
import RadioGroup from '../RadioGroup';
import OwnerAddOnsWizard, {
  type OwnerAddOnsAnswersType,
} from '../OwnerAddOnsWizard';

type PropsType = {
  onClick?: () => void;
  className?: string;
  isSingleSkipTrace?: boolean;
  onFileUploadChange?: (value: boolean) => void;
  onOwnerAddOnsStepChange?: (stepId: string | null) => void;
  onMappingOpenChange?: (isOpen: boolean) => void;
  presetSkipTraceType?: string;
  hideTypeSelector?: boolean;
} & React.PropsWithChildren;

interface IObject {
  [key: string]: string;
}
interface IFileInfo {
  name: string;
  size: number;
  fields: string[];
  records: number;
  data: IObject[];
}

const initialFileInfo: IFileInfo = { name: '', size: 0, records: 0, fields: [], data: [] }

const DragAndDropArea: React.FC<PropsType> = (props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isLoading = useAppSelector(
    (state) => state.orderSlice.addition.isLoading
  );
  const userInfo = useAppSelector((state) => state.userSlice.user);
  const userSubscription = userInfo.subscription;
  const currentDiscount = userInfo.discount ? userInfo.discount : 0;
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);
  const [isOpenBillModal, setIsOpenBillModal] = useState(false);
  const [fileInfo, setFileInfo] = useState<IFileInfo>(initialFileInfo);
  const [isOpenErrorMappingModal, setIsOpenErrorMappingModal] = useState(false);
  const [isOpenErrorBalanceModal, setIsOpenErrorBalanceModal] = useState(false);
  const [isOpenErrorCountRecordsModal, setIsOpenErrorCountRecordsModal] =
    useState(false);
  const [isOpenAddSkipTraceModal, setIsOpenAddSkipTraceModal] = useState(false);
  const [isOpenMapping, setIsOpenMapping] = useState(false);
  const [isOpenOwnerAddOns, setIsOpenOwnerAddOns] = useState(false);
  const [skipTraceType, setSkipTraceType] = useState<string>(
    props.presetSkipTraceType || SkipTraceFileTypeENUM.OWNER_MAILING_ADDRESS
  );
  const shouldShowOwnerAddOns =
    Boolean(props.hideTypeSelector) &&
    skipTraceType === SkipTraceFileTypeENUM.OWNER_MAILING_ADDRESS;
  const skipTraceFields = SkipTraceFileHeaders[skipTraceType];
  const requiredFields = SkipTraceFileRequiredHeaders[skipTraceType];
  const requiredFieldsMappings = SkipTraceFieldMapping[skipTraceType];
  useEffect(() => {
    dispatch(setDiscount({ discount: currentDiscount }));
    dispatch(unsetUploadFile());
  }, [])
  useEffect(() => {
    if (props.presetSkipTraceType) {
      setSkipTraceType(props.presetSkipTraceType);
    }
  }, [props.presetSkipTraceType]);
  useEffect(() => {
    props.onMappingOpenChange?.(isOpenMapping && !isOpenOwnerAddOns);
  }, [isOpenMapping, isOpenOwnerAddOns, props.onMappingOpenChange]);
  useEffect(() => {
    return () => props.onMappingOpenChange?.(false);
  }, [props.onMappingOpenChange]);
  const destinationFields = skipTraceType === SkipTraceFileTypeENUM.OWNER_MAILING_ADDRESS ? skipTraceFields : requiredFields;
  const [file, setFile] = useState<File | null>(null);
  const isLocked = (fileType: string) => {
    // if (!userSubscription?.id) {
    //   return true;
    // }
    if(fileType === SkipTraceFileTypeENUM.BUSSINESS || fileType === SkipTraceFileTypeENUM.PHONE) {
      return true;
    }

    if (fileType === SkipTraceFileTypeENUM.BLACKLISTED || fileType === SkipTraceFileTypeENUM.DNC) {
      return !userInfo.isBlacklistFree;
    }
    if (fileType === SkipTraceFileTypeENUM.EMAIL || fileType === SkipTraceFileTypeENUM.PHONE) {
      return ['starter', 'growth'].includes(userSubscription?.type.toLowerCase() || '');
    }
    return false;
  };

  const ownerOptions = Object.values(OwnerTypeENUM).map((fileType) => (
    { label: fileType, value: fileType, disabled: isLocked(fileType) }
  ));

  const businessOptions = Object.values(BusinessTypeENUM).map((fileType) => (
    { label: fileType, value: fileType, disabled: isLocked(fileType) }
  ));

  const dncOptions = Object.values(ScrubTypeENUM).map((fileType) => (
    { label: fileType, value: fileType, disabled: isLocked(fileType) }
  ));

  const handleRadioChange = (value: string) => {
    setSkipTraceType(value);
  };

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const isActiveEvent = e.type === 'dragenter' || e.type === 'dragover';
    if (!isFileUpload) {
      if (isActiveEvent) {
        setIsDragActive(true);
      } else if (e.type === 'dragleave') {
        setIsDragActive(false);
      }
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    if (!isFileUpload) {
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        if (e.dataTransfer.files[0].name.endsWith('.csv')) {
          handleUploadeFile(e.dataTransfer.files[0]);
        }
      }
    }
  };

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setIsOpenErrorCountRecordsModal(false);
    setIsOpenErrorBalanceModal(false);
    if (e.target.files && e.target.files[0]) {
      const currentFile = e.target.files[0];
      if (currentFile.name.endsWith('.csv')) {
        handleUploadeFile(currentFile)
      }
    }
  };

  const handleUploadeFile = async (file: File) => {
    if (file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      toast.error(`File size is too large. Maximum allowed file size is ${MAX_UPLOAD_FILE_SIZE_LABEL}.`);
      props?.onFileUploadChange?.(false);
      return;
    }

    try {
      props?.onFileUploadChange?.(true)
      setFileInfo({ name: file.name, size: file.size, records: 0, fields: [], data: [] });
      setIsFileUpload(true);
      setFile(file);
      dispatch(setLoading());
      const { records, fields, data } = await parseFile(file);
      if (records <= 1) {
        toast.error("File should not be empty.")
        setIsFileUpload(false);
        setFileInfo(initialFileInfo);
        setFile(null);
        props?.onFileUploadChange?.(false);
      }
      else {
        const nextFileInfo = { name: file.name, size: file.size, records, fields, data };
        setFileInfo(nextFileInfo);
        if (props.hideTypeSelector) {
          await runReviewOrder(nextFileInfo);
        }
      }
    }
    catch (error) {
      toast.error(error)
      setIsFileUpload(false);
      setFileInfo(initialFileInfo);
      setFile(null);
      props?.onFileUploadChange?.(false);
    } finally {
      dispatch(unsetLoading());
    }
  }

  const onUploadFile_ = async (name: string, csvBase64: string, records: number, fields: string[]) => {
    try {
      dispatch(
        setUploadFile({
          name: getUploadFileName(name),
          csvBase64,
          records,
          fields,
          skipTraceType,
        })
      );
      setIsOpenErrorMappingModal(false);
      setIsOpenErrorCountRecordsModal(false);
      setIsOpenErrorBalanceModal(false);
    } catch (error) {
      toast.error(error)
    }
  }

  const openBillOrOwnerAddOns = () => {
    if (shouldShowOwnerAddOns) {
      setIsOpenMapping(false);
      setIsOpenOwnerAddOns(true);
      // Notify parent in the same turn so the email price panel mounts with the wizard
      props.onOwnerAddOnsStepChange?.('email');
      return;
    }
    setIsOpenBillModal(true);
  };

  const handleOwnerAddOnsComplete = (answers: OwnerAddOnsAnswersType) => {
    dispatch(
      setFileMetadata({
        email: answers.email,
        blacklist: answers.blacklist,
        dnc: answers.dnc,
      }),
    );
    setIsOpenOwnerAddOns(false);
    props.onOwnerAddOnsStepChange?.(null);
    setIsOpenBillModal(true);
  };

  const handleSkipTraceType = async (
    dnc: boolean,
    mappings: IObject,
    currentFileInfo: IFileInfo = fileInfo,
  ) => {
    dispatch(setFileMetadata({ blacklist_columns: Object.values(mappings), dnc }));
    const csvFile = await createCsvFile(currentFileInfo.data);
    const csvBase64 = convertToBase64(csvFile);
    onUploadFile_(
      currentFileInfo.name,
      csvBase64,
      currentFileInfo.records,
      currentFileInfo.fields,
    );
    setIsOpenBillModal(true);
  };

  const onApplyMapping = async (
    mappings: IObject,
    currentFileInfo: IFileInfo = fileInfo,
  ) => {
    try {
      const { name, records, data, fields } = currentFileInfo;
      if (records > 1) {
        if (skipTraceType === SkipTraceFileTypeENUM.BLACKLISTED) {
          await handleSkipTraceType(false, mappings, currentFileInfo);
          return;
        }
        if (skipTraceType === SkipTraceFileTypeENUM.DNC) {
          await handleSkipTraceType(true, mappings, currentFileInfo);
          return;
        }
        const filter = (row: IObject) => {
          const newRow: IObject = {};
          skipTraceFields.forEach(newField => {
            if (mappings[newField]) {
              newRow[newField] = row[mappings[newField]];
            } else {
              newRow[newField] = ""
            }
          });
          return newRow;
        }
        const csvFile = await createCsvFile(data, filter)
        const csvBase64 = convertToBase64(csvFile);

        onUploadFile_(name, csvBase64, records, skipTraceFields);
        openBillOrOwnerAddOns();
      }
    } catch (error) {
      console.error("here", error);
      toast.error(error)
    }
  }

  const deleteFile = async () => {
    try {
      dispatch(unsetUploadFile());
      setIsFileUpload(false);
      setFileInfo(initialFileInfo);
      setIsOpenMapping(false)
      setIsOpenOwnerAddOns(false);
      props.onOwnerAddOnsStepChange?.(null);
      setSkipTraceType(
        props.presetSkipTraceType || SkipTraceFileTypeENUM.OWNER_MAILING_ADDRESS
      );
      props?.onFileUploadChange?.(false)
      setFile(null);
    } catch (error) {
      toast.error(error);
    }
  };

  const runReviewOrder = async (currentFileInfo: IFileInfo = fileInfo) => {
    var cost = 0;
    const { name, records, data, fields } = currentFileInfo;
    if (fields.length < requiredFields.length) {
      setIsOpenErrorMappingModal(true);
      return
    }
    if (
      skipTraceType === SkipTraceFileTypeENUM.BLACKLISTED ||
      skipTraceType === SkipTraceFileTypeENUM.DNC
    ) {
      cost = config.blacklistPricePerRecord * (records - 1) * (1 - currentDiscount);
    }
    else if (SkipTraceFileTypeENUM.BUSSINESS === skipTraceType) {
      cost = (records - 1) * userInfo.llcCost;
    }
    else if (
      currentDiscount !== 0 &&
      userInfo.code === config.firstTimeCoupon.code &&
      (records - 1) > config.firstTimeCoupon.upto
    ) {
      const discountAmount =
        config.firstTimeCoupon.upto *
        userInfo.rowCost *
        (currentDiscount / 100);

      cost = (records - 1) * userInfo.rowCost - discountAmount;
    }
    else {
      cost = (records - 1) * userInfo.rowCost * (1 - currentDiscount);
    }
    if (userInfo.balance < cost) {
      setIsOpenErrorBalanceModal(true);
    }
    else if (isValidFileHeaders(popStreamFileHeaders, fields)) {
      onApplyMapping(popStreamFileFieldMapping, currentFileInfo);
    }
    else if (!isValidFileHeaders(skipTraceFields, fields)) {
      setIsOpenMapping(true)
    }
    else {
      const filter = (row: IObject) => {
        const newRow: IObject = {};
        skipTraceFields.forEach(newField => {
          if (row[newField]) {
            newRow[newField] = row[newField];
          } else {
            newRow[newField] = ""
          }
        });
        return newRow;
      }
      const csvFile = await createCsvFile(data, filter)
      const csvBase64 = convertToBase64(csvFile);
      onUploadFile_(name, csvBase64, records, fields);
      openBillOrOwnerAddOns();
    }
  };

  const onClickReviewOrder = async () => {
    await runReviewOrder();
  };
  const handleCloseBillModal = () => {
    setIsOpenBillModal(false);
  };

  const onClickCancelBalanceModal = () => {
    setIsFileUpload(false);
    setIsOpenErrorBalanceModal(false);
  };

  const onCurrentClickBalanceModal = () => {
    navigate('/payments/enter-amount');
  };

  const onClickCancelRecordsModal = () => {
    setIsFileUpload(false);
    setIsOpenErrorCountRecordsModal(false);
  };

  const onClickCancelMappingModal = () => {
    setIsFileUpload(false);
    setIsOpenErrorMappingModal(false);
  };

  const onClickCancelAddSkipTraceModal = () => {
    setIsOpenAddSkipTraceModal(false);
  };

  const onClickOpenAddSkipTraceModal = () => {
    setIsOpenAddSkipTraceModal(true);
  };

  const handleAddSkipTrace = async (values: IObject) => {
    if (skipTraceType === SkipTraceFileTypeENUM.BLACKLISTED) {
      dispatch(setFileMetadata({ blacklist_columns: Object.values(SkipTraceFileHeaders[SkipTraceFileTypeENUM.BLACKLISTED]), dnc: false }));
    } else if (skipTraceType === SkipTraceFileTypeENUM.DNC) {
      dispatch(setFileMetadata({ blacklist_columns: Object.values(SkipTraceFileHeaders[SkipTraceFileTypeENUM.BLACKLISTED]), dnc: true }));
    }
    const csvFile = await createCsvFile([values])
    const csvBase64 = convertToBase64(csvFile);
    onUploadFile_('single-skip-trace.csv', csvBase64, 2, skipTraceFields);
    setIsOpenAddSkipTraceModal(false);
    setIsOpenBillModal(true);
  }

  return (
    <StyledDragAndDropArea
      onClick={props?.onClick}
      className={props?.className ?? ''}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
      isDragActive={isDragActive && !isFileUpload}
    >
      {
        props.isSingleSkipTrace ? (
          <>
            <div className="styled-drag-and-drop-area__text-area">
              <RadioGroup label='Select Skiptrace Type' ownerOptions={ownerOptions} businessOptions={businessOptions} dncOptions={dncOptions} onChange={handleRadioChange} defaultValue={skipTraceType} llcCost={userInfo.llcCost} rowCost={userInfo.rowCost} isBlacklistFree={userInfo.isBlacklistFree} />
            </div>
            <Button variant="contained" sx={{ py: 1.5, borderRadius: 2 }} onClick={onClickOpenAddSkipTraceModal}>
              <h4>Add</h4>
            </Button>
          </>
        ) : (
          <FileUpload
            isLoading={isLoading}
            isFileUpload={isFileUpload}
            fileInfo={fileInfo}
            handleChange={handleChange}
            deleteFile={deleteFile}
          />
        )
      }

      {!isOpenMapping && isFileUpload && !props.hideTypeSelector && (
        <div className="styled-drag-and-drop-area__step-enter">
          <div className="styled-drag-and-drop-area__text-area">
            <RadioGroup label='Select Skiptrace Type' ownerOptions={ownerOptions} businessOptions={businessOptions} dncOptions={dncOptions} onChange={handleRadioChange} defaultValue={skipTraceType} llcCost={userInfo.llcCost} rowCost={userInfo.rowCost} isBlacklistFree={userInfo.isBlacklistFree} />
          </div>
          <Button endIcon={<ArrowRightIcon fill="white" />} variant="contained" sx={{ py: 1.5, borderRadius: 2 }} onClick={onClickReviewOrder}>
            <h4>Review Order</h4>
          </Button>
        </div>
      )}

      {isOpenMapping && !isOpenOwnerAddOns && (
        <div className="styled-drag-and-drop-area__step-enter">
          <MappingData
            sourceFields={fileInfo.fields}
            destinationFields={destinationFields}
            onApplyMapping={onApplyMapping}
            fieldMappings={requiredFieldsMappings}
            skipTraceType={skipTraceType}
          />
        </div>
      )}

      {isOpenOwnerAddOns && (
        <OwnerAddOnsWizard
          canAskScrubOptions={userInfo.isBlacklistFree}
          onComplete={handleOwnerAddOnsComplete}
          onStepChange={props.onOwnerAddOnsStepChange}
        />
      )}

      {isOpenBillModal ? (
        <Bill
          open={isOpenBillModal}
          onClose={handleCloseBillModal}
          file={file}
        />
      ) : null}

      {isOpenErrorMappingModal ? (
        <ErrorMappingModal
          handleChange={handleChange}
          onCloseModal={onClickCancelMappingModal}
        />
      ) : null}

      {isOpenErrorBalanceModal ? (
        <ErrorBalanceModal
          onCloseModal={onClickCancelBalanceModal}
          onClick={onCurrentClickBalanceModal}
        />
      ) : null}

      {isOpenErrorCountRecordsModal ? (
        <ErrorCountRecordsModal
          handleChange={handleChange}
          onCloseModal={onClickCancelRecordsModal}
        />
      ) : null}

      {isOpenAddSkipTraceModal ? (
        <AddSkipTraceModal
          skipTraceType={skipTraceType}
          onUploadFile={handleAddSkipTrace}
          onCloseModal={onClickCancelAddSkipTraceModal}
        />
      ) : null}
    </StyledDragAndDropArea>
  );
};

export default DragAndDropArea;
